// Oś czasu wykresu na Przeglądzie.
//
// Backend grupuje wysyłki po tygodniach i zwraca wyłącznie te tygodnie, w
// których cokolwiek poszło. Tydzień bez ani jednej wysyłki nie ma wiersza,
// więc narysowany wprost wykres skłamałby o ciągłości czasu: osiem słupków
// obok siebie wyglądałoby na osiem kolejnych tygodni, a byłyby to dowolne
// tygodnie z ostatnich dwóch miesięcy. Dziury dopełniamy zerami.

export interface ResponseRateWeek {
  week_start: string;
  sent: number;
  answered: number;
}

/**
 * Poniedziałek tygodnia, w którym leży data. Postgres tnie przez
 * `date_trunc('week')`, a ten liczy tydzień od poniedziałku - robimy tak samo,
 * inaczej klucze się nie spotkają.
 */
function mondayOf(date: Date): Date {
  const start = new Date(
    Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0),
  );
  const dayFromMonday = (start.getUTCDay() + 6) % 7;
  start.setUTCDate(start.getUTCDate() - dayFromMonday);
  return start;
}

/**
 * Dokłada brakujące tygodnie tak, żeby wyszło dokładnie `count` kolejnych
 * tygodni kończących się tygodniem bieżącym. Tygodnie spoza tego okna
 * odpadają - wykres ma stałą szerokość osi.
 */
export function fillWeeks(
  weeks: ResponseRateWeek[],
  count: number,
  now: Date = new Date(),
): ResponseRateWeek[] {
  const znane = new Map<number, ResponseRateWeek>();
  for (const week of weeks) {
    const start = new Date(week.week_start);
    if (Number.isNaN(start.getTime())) continue;
    znane.set(mondayOf(start).getTime(), week);
  }

  const ostatni = mondayOf(now);
  const wynik: ResponseRateWeek[] = [];
  for (let wstecz = count - 1; wstecz >= 0; wstecz -= 1) {
    const start = new Date(ostatni);
    start.setUTCDate(start.getUTCDate() - wstecz * 7);
    const klucz = start.getTime();
    wynik.push(
      znane.get(klucz) ?? { week_start: start.toISOString(), sent: 0, answered: 0 },
    );
  }
  return wynik;
}
